import {
  useBreakpointValue,
  Stack,
  Box,
  Heading,
  Container,
  Button,
  Text,
} from '@chakra-ui/react'
import { Logo } from '@components/Elements/Logo'
import { SignInForm } from '@features/auth/components/SignInForm'
import { core, firebaseClientInitConfig } from '@lib/firebase/config'
import {
  createFileRoute,
  useNavigate,
  useSearch,
  Link,
} from '@tanstack/react-router'
import { FaCaretRight } from 'react-icons/fa6'
import { Route as StaffForgotPasswordRoute } from '@routes/staff_.forgotPassword'
import { z } from 'zod'

const TENANT = firebaseClientInitConfig.tenantIds.staff

const StaffSignInComponent = () => {
  const breakPointValue = useBreakpointValue({ base: 'xs', md: 'sm' })

  const search = useSearch({ from: '/staff_/signin' })
  const navigate = useNavigate({ from: '/staff/signin' })

  const redirectUrl = search?.redirect ?? core.staffAppPageUrl

  return (
    <Container
      maxW="md"
      py={{ base: '12', md: '24' }}
      bgGradient="linear(to-b, gray.800, gray.700, gray.800)"
    >
      <Stack spacing="8">
        <Stack spacing="5">
          <Box px="120" py="50" marginTop="30px">
            <Logo textColor={'orange'} />
            <Heading textAlign={'center'} mt={2}>
              STAFF
            </Heading>
          </Box>
          <Stack spacing={{ base: '2', md: '3' }} textAlign="center">
            <Heading size={breakPointValue}>
              Log in to your staff account
            </Heading>
          </Stack>
        </Stack>
        <Stack spacing="6">
          <SignInForm
            tenant={TENANT}
            navigate={navigate}
            redirectUrl={redirectUrl}
            forgotPasswordElement={
              <Link to={StaffForgotPasswordRoute.to}>
                <Button variant="link" colorScheme="blue" size="sm">
                  Forgot password
                </Button>
              </Link>
            }
          />
        </Stack>
        <Stack align={'center'} gap={2}>
          <Text>Trying to log in as user?</Text>
          <a href={'/signin'}>
            <Button variant={'link'} size={'xs'} rightIcon={<FaCaretRight />}>
              Go here instead
            </Button>
          </a>
        </Stack>
      </Stack>
    </Container>
  )
}

const routerSchema = z.object({
  redirect: z.string().optional(),
})

export const Route = createFileRoute('/staff_/signin')({
  component: StaffSignInComponent,
  validateSearch: routerSchema,
})
